import { Link } from 'react-router-dom'
import type { ProjectDetail } from '../../../features/projects/types'

interface ProjectCardProps {
  project: ProjectDetail
  index?: number
  className?: string
}

const ProjectCard = ({ project, index = 0, className = '' }: ProjectCardProps) => {
  // Tách tiêu đề và mã công trình từ định dạng: "Tên công trình | Mã số"
  const parts = project.title.split('|')
  const displayTitle = parts[0].trim()
  const projectCode = parts[1] ? parts[1].trim() : null

  const localLink = `/chi-tiet/${project.slug || project.id}`

  return (
    <Link
      to={localLink}
      title={project.title}
      className={`project-card card-animate ${className}`}
      style={{ '--index': index } as React.CSSProperties}
    >
      {/* Image */}
      <div className="project-card__image-wrap">
        {project.coverImage ? (
          <img
            src={project.coverImage}
            alt={project.title}
            className="project-card__image"
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={(e) => {
              // Ẩn ảnh nếu lỗi, hiện placeholder
              const target = e.currentTarget
              target.style.display = 'none'
              const parent = target.parentElement
              if (parent) {
                const placeholder = document.createElement('div')
                placeholder.className = 'project-card__no-image'
                placeholder.textContent = '🏡 Đang cập nhật'
                parent.appendChild(placeholder)
              }
            }}
          />
        ) : (
          <div className="project-card__no-image">🏡 Đang cập nhật</div>
        )}

        {/* Overlay on hover */}
        <div className="project-card__overlay">
          <div className="project-card__overlay-content">
            <span className="project-card__view-btn">
              <i className="fas fa-eye" />
              Xem chi tiết
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="project-card__body">
        <h4 className="project-card__title" title={project.title}>
          {displayTitle}
        </h4>
        <div className="project-card__meta">
          {projectCode ? (
            <span className="project-card__code">
              <i className="fas fa-tag" style={{ marginRight: '4px', fontSize: '10px' }} />
              {projectCode}
            </span>
          ) : (
            <span className="project-card__code-placeholder"></span>
          )}
          <span className="project-card__price">
            {project.price && project.price !== '[Liên hệ]' ? project.price : 'Liên hệ'}
          </span>
        </div>
      </div>
    </Link>
  )
}

export default ProjectCard
